import {
  ENGINEERING_SYSTEMS_CDN_PATH,
  ENGINEERING_SYSTEMS_LANDING_NAME,
} from '../../../engineering-systems-constants';
import { GalleryListStructure } from '../../../components';

export const HEATING_GALLERY_LIST: GalleryListStructure[] = [
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/1.jpg/1.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-1b.jpg/heating-1b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-1b.jpg/heating-1b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '1.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/2.jpg/2.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-2b.jpg/heating-2b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-2b.jpg/heating-2b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '2.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/3.jpg/3.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-3b.jpg/heating-3b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-3b.jpg/heating-3b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '3.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/4.jpg/4.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-4b.jpg/heating-4b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-4b.jpg/heating-4b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '4.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/5.jpg/5.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-5b.jpg/heating-5b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-5b.jpg/heating-5b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '5.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/6.jpg/6.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-6b.jpg/heating-6b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-6b.jpg/heating-6b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '6.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/7.jpg/7.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-7b.jpg/heating-7b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-7b.jpg/heating-7b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '7.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/8.jpg/8.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-8b.jpg/heating-8b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-8b.jpg/heating-8b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '8.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/9.jpg/9.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-9b.jpg/heating-9b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-9b.jpg/heating-9b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '9.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/10.jpg/10.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-10b.jpg/heating-10b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-10b.jpg/heating-10b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '10.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/11.jpg/11.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-11b.jpg/heating-11b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-11b.jpg/heating-11b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '11.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/heating/popup/12.jpg/12.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-12b.jpg/heating-12b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/heating-12b.jpg/heating-12b.jpg`,
    alt: 'Пример установки системы отопления',
    name: '12.jpg',
  },
];
